import React from 'react';
import { Container, Grid, Box, Typography } from '@mui/material';
import { FaHandshake, FaClock, FaStar, FaLightbulb } from 'react-icons/fa';
import './ValuesSection.css';

const ValuesSection = () => {
  const values = [
    {
      icon: <FaHandshake />,
      title: 'Confiance',
      description: 'Des profils vérifiés et des évaluations transparentes pour garantir la qualité de chaque collaboration.'
    },
    {
      icon: <FaClock />,
      title: 'Flexibilité',
      description: 'Des missions adaptées à vos besoins et disponibilités, pour une collaboration sur mesure.'
    },
    {
      icon: <FaStar />,
      title: 'Qualité',
      description: 'Une sélection rigoureuse des professionnels pour assurer l\'excellence dans chaque mission.'
    },
    {
      icon: <FaLightbulb />,
      title: 'Innovation',
      description: 'Une plateforme moderne qui révolutionne la mise en relation dans le monde du sport.'
    }
  ];

  return (
    <section className="values-section">
      <Container maxWidth="lg">
        <Box className="values-header">
          <Typography variant="h2" className="values-title">
            Nos Valeurs
          </Typography>
          <Typography variant="body1" className="values-subtitle">
            Les principes qui guident notre mission et façonnent notre plateforme
          </Typography>
        </Box>
        
        <Grid container spacing={4} className="values-grid">
          {values.map((value, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Box className="value-card">
                <div className="value-icon">
                  {value.icon}
                </div>
                <Typography variant="h3" className="value-title">
                  {value.title}
                </Typography>
                <Typography variant="body2" className="value-description">
                  {value.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default ValuesSection;